export const gridStyles = {
  bgcolor: "#888888",
  mt: 5,
  width: "35%",
  borderRadius: "20px",
  pr: "15px",
  pb: "15px",
  minHeight: "400px",
};
